import { ILaboratorioAnalise } from "@/interfaces/ILaboratorioAnalise";
import { createAction } from "@reduxjs/toolkit";

const sync = createAction(
  "LABORATORIO/sync",
  (items: ILaboratorioAnalise[]) => ({
    payload: { items },
  })
);

export const laboratorioAction = { sync };
